import { Avatar, Stack, Typography } from '@mui/material';
import type { FC, ReactNode } from 'react';
import type { BadgeOption } from '../enums/BadgeOptions';
import { BADGE_OPTIONS } from '../enums/BadgeOptions';
import { CardBadge } from './CardBadge/CardBadge';

export type CardHeaderProps = {
  title: string;
  subtitle: string;
  logo: ReactNode;
  imageLogo?: boolean;
  showConnectedBadge: boolean;
  showNotSupportedBadge: boolean;
};

export const CardHeader: FC<CardHeaderProps> = ({
  title,
  subtitle,
  logo,
  imageLogo,
  showConnectedBadge,
  showNotSupportedBadge,
}) => {
  const badgeOption = getPreferredBadgeOption(showConnectedBadge, showNotSupportedBadge);

  return (
    <Stack
      direction="row"
      sx={{
        justifyContent: "space-between",
        alignItems: "flex-start"
      }}>
      <Stack direction="row" spacing={1.5} sx={{
        alignItems: "center"
      }}>
        {imageLogo ? (
          logo
        ) : (
          <Avatar
            alt={title}
            sx={{ width: 54, height: 54, background: 'transparent', borderRadius: '10px' }}
            variant="square"
          >
            {logo}
          </Avatar>
        )}

        <Stack spacing={0.5}>
          <Typography variant="h6">{title}</Typography>
          <Typography variant="caption" sx={{
            color: "text.secondary"
          }}>
            {subtitle}
          </Typography>
        </Stack>
      </Stack>
      {badgeOption && <CardBadge badgeOption={badgeOption} />}
    </Stack>
  );
};

function getPreferredBadgeOption(
  showConnectedBadge: boolean,
  showNotSupportedBadge: boolean,
): BadgeOption | undefined {
  if (showConnectedBadge) {
    return BADGE_OPTIONS.Connected;
  }
  if (showNotSupportedBadge) {
    return BADGE_OPTIONS.NotSupported;
  }

  return undefined;
}
